import { N0BoardingPasses } from './boarding-pass.models';
import { TransportationIdentifier } from './responses/availability-response.model';

export interface N0CheckinStatus {
  journeyKey: string;
  passengers: { [key: string]: CheckinPassengerLiftStatus[] };
}

export interface CheckinPassengerLiftStatus {
  identifier: TransportationIdentifier;
  status: LiftStatusEnum;
}

export enum LiftStatusEnum {
  DEFAULT,
  CHECKED_IN,
  BOARDED,
  NO_SHOW,
}

export interface N0CheckinResponse {
  boardingPasses: N0BoardingPasses;
  checkinAttemptResponses: N0CheckinAttemptResponse[];
}

export interface N0CheckinAttemptResponse {
  journeyKey: string;
  passengers: N0CheckinAttemptPassengerResponse[];
}

export interface N0CheckinAttemptPassengerResponse {
  errors: CheckinErrorType[];
  passegnerKey: string;
  status: CheckinPassengerLiftStatus;
}

export enum CheckinErrorType {
  NONE,
  ONE_WAY_US,
  DOCUMENTS_MISSING,
  RESTRICTED_SSR,
  NEED_SEATS,
  MISSING_ADDRESS,
  CHECKIN_FAILED,
  BOARDING_PASS_FAILED,
  RESTRICTED_ORIGIN,
  DOC_CHECK_FAILED,
}

export interface N0CheckinDocCheckResponse {
  journeys: N0CheckinDocCheckJourney[];
  status: N0DocCheckMessageStatus;
}

export interface N0CheckinDocCheckJourney {
  journeyKey: string;
  passengers: N0CheckinDocCheckPassenger[];
  status: N0DocCheckMessageStatus;
}

export interface N0CheckinDocCheckPassenger {
  messages: N0CheckinDocCheckJourneysMessage[];
  passengerKey: string;
  status: N0DocCheckMessageStatus;
}

export interface N0CheckinDocCheckJourneysMessage {
  important: boolean;
  message: string;
  messageCode: string;
  messageStatus: N0DocCheckMessageStatus;
}

export enum N0DocCheckMessageStatus {
  None = 0,
  Green = 1,
  Amber = 2,
  Red = 3,
}
